export const SEMINAR_STATUS = [
  {
    label: "개별",
    value: "single"
  },
  {
    label: "정기",
    value: "periodic"
  },
];

export const SEMINAR_PERIODIC_CYCLE_UNIT = [
  { label: "매주", value: "week" },
  { label: "매월", value: "month" },
  { label: "매년", value: "year" },
  { label: "매일", value: "date" },
];
export const SEMINAR_SINGLE_CYCLE_UNIT = [
  { label: "추가일정", value: "additions" },
  { label: "대체일정", value: "alternatives" },
];